export const MEDIA_QUERY = {
  SMALL_MAX_WIDTH: 767
};
